import React, { useContext, useEffect, useState } from 'react';
import LoginLayoutComponent from '../LoginLayoutComponent/LoginLayoutComponent';
import './LoginBanner.scss';
import { PageContext } from '../../../contexts/ContextCreator';
import { POPUP_MODE } from '../LoginLayoutComponent/Layouts/LogInLayout/constants';

const LoginBanner = () => {
    const {
        leadInLogin,
        getLoginWallData,
        loginWall,
        setLeadLoginInPopup,
        showLeadinPopup,
    } = useContext(PageContext);
    const [loginData, setLoginData] = useState(null);

    useEffect(() => {
        const results = getLoginWallData();
        setLoginData(results);
    }, [getLoginWallData, loginWall]);

    useEffect(() => {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlParams.entries());
            if (params?.scroll) {
                window.scrollTo({
                    top: params.scroll - 150,
                    behavior: 'smooth',
                });
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, []);

    const renderLogin = () => {
        const {
            auth0,
            closeLoginWall,
            layoutType,
            loginRedirectPath,
            loginWallData,
            redirectUri,
        } = loginData;

        const { placementName, allowClosing } = loginWallData;

        return loginData ? (
            <div className="component-Login-LoginBanner leadInLogin">
                {!showLeadinPopup && (
                    <div className="component-Login-LoginBanner-container">
                        <div className="component-LeadInLogin-container">
                            <LoginLayoutComponent
                                leadInLogin={leadInLogin && !showLeadinPopup}
                                setLeadLoginInPopup={setLeadLoginInPopup}
                                auth0={auth0}
                                hidePopup={closeLoginWall}
                                displayMode={POPUP_MODE}
                                layoutType={layoutType}
                                loginRedirectPath={loginRedirectPath}
                                redirectUri={redirectUri}
                                allowClosing={allowClosing === 1}
                                loginMetrics={{
                                    login_trigger: 'signup-wall',
                                    test_flag: placementName,
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
        ) : null;
    };

    return loginData && leadInLogin ? renderLogin() : null;
};

export default LoginBanner;
